var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m5.91309 3.99996-5.8695694 3.38879.0000003-6.777588z"}));
}

Play.defaultProps = {"height":"8","viewBox":"0 0 6 8","width":"6"};

module.exports = Play;

Play.default = Play;
